//
// Copyright (c) 2011-2023 by Curalate, Inc.
//
import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';

export const getTwitterUserId = createSelector(
  (state: ICuralateStore) => state.twitter.user,
  (twitterUserState) => twitterUserState.user?.id,
);
